// This file contains all the constants used in the application

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 1. Home 
// Name
export const NAME = "Jane Doe";

// Designation
export const DESIGNATION = "Full Stack Developer";

// Description
export const DESCRIPTION = "High level experience in web application development and producing quality work.";




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 2. About
// Detailed Description
export const DETAILED = "I am a passionate Full Stack Developer with 2+ years of experience in web application development and producing quality work. I have worked on multiple projects and have a good understanding of the latest technologies. I am a quick learner and have a good problem-solving skill. I am looking for an opportunity to work in a challenging environment and grow my career.";

// Experience
export const EXPERIENCE = "2+";

// Companies
export const COMPANIES = "2+";

// Projects
export const PROJECTS = "7+";

// Resume
export const RESUME = "./assets/pdf/Resume.pdf";




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 3. Social Media Links
// Github username
export const GITHUB = "janedoe";

// Stackoverflow URL
export const STACKOVERFLOW = "https://stackoverflow.com/users/18698830/jane-Doe";

// LinkedIn username
export const LINKEDIN = "janedoe";

// Twitter username
export const TWITTER = "janedoe";

// Facebook username
export const FACEBOOK = "janedoe";

// Instagram username
export const INSTAGRAM = "janedoe";


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 4. Skills
export const SKILLS = [
    {
        name: 'Frontend',
        description: 'Frontend Description',
        SubSkill: [
            {
                name: 'HTML5',
                level: '90'
            },
            {
                name: 'HTML4',
                level: '80'
            },
        ]
    },
    {
        name: 'Backend',
        description: 'Backend Description',
        SubSkill: [
            {
                name: 'Firebase',
                level: '90'
            },
            {
                name: 'Azure',
                level: '50'
            },
            {
                name: 'AWS',
                level: '70'
            },
            {
                name: 'Google Cloud',
                level: '90'
            }
        ]
    }
]


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 4. Qualifications
// EDUCATION1
export const EDUCATION_DEGREE1 = "BTech in Computer Science";
export const EDUCATION_NAME1 = "University of California, Los Angeles";
export const EDUCATION_DATE1 = "2008 - 2010";

// EDUCATION2
export const EDUCATION_DEGREE2 = "MTech in Computer Science";
export const EDUCATION_NAME2 = "Harvard, Los Angeles";
export const EDUCATION_DATE2 = "2011 - 2011";

// EDUCATION3
export const EDUCATION_DEGREE3 = "Master of Science in Computer Science";
export const EDUCATION_NAME3 = "LA, Los Angeles";
export const EDUCATION_DATE3 = "2012 - 2015";

// WORK1
export const WORK_TITLE1 = "Frontend Developer";
export const WORK_COMPANY1 = "Google";
export const WORK_DATE1 = "2011 - 2015";
export const WORK_DESCRIPTION1 = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.";

// WORK2
export const WORK_TITLE2 = "Backend Developer";
export const WORK_COMPANY2 = "Facebook";
export const WORK_DATE2 = "2015 - 2018";
export const WORK_DESCRIPTION2 = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.";

// WORK3
export const WORK_TITLE3 = "FullStack Developer";
export const WORK_COMPANY3 = "Microsoft";
export const WORK_DATE3 = "2018 - 2022";
export const WORK_DESCRIPTION3 = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.";



//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 5. Services
export const SERVICES = [
    {
        icon: 'fa fa-code',
        name: 'Web Development',
        description: [
            {
                name: 'Web Development Description 1',
            },
            {
                name: 'Web Development Description 2',
            },
            {
                name: 'Web Development Description 3',
            },
        ],
    },
    {
        icon: 'fa fa-mobile',
        name: 'Mobile Development',
        description: [
            {
                name: 'Mobile Development Description 1',
            },
            {
                name: 'Mobile Development Description 2',
            },
            {
                name: 'Mobile Development Description 3',
            },
        ],
    },
    {
        icon: 'fa fa-paint-brush',
        name: 'UI/UX Design',
        description: [
            {
                name: 'UI/UX Design Description 1',
            },
            {
                name: 'UI/UX Design Description 2',
            },
            {
                name: 'UI/UX Design Description 3',
            },
        ],
    },
    {
        icon: 'fa fa-line-chart',
        name: 'Digital Marketing',
        description: [
            {
                name: 'Digital Marketing Description 1',
            },
            {
                name: 'Digital Marketing Description 2',
            },
            {
                name: 'Digital Marketing Description 3',
            },
        ],
    },
    {
        icon: 'fa fa-search',
        name: 'SEO',
        description: [
            {
                name: 'SEO Description 1',
            },
            {
                name: 'SEO Description 2',
            },
            {
                name: 'SEO Description 3',
            },
        ],
    },
    {
        icon: 'fa fa-cloud',
        name: 'Cloud Computing',
        description: [
            {
                name: 'Cloud Computing Description 1',
            },
            {
                name: 'Cloud Computing Description 2',
            },
            {
                name: 'Cloud Computing Description 3',
            },
        ],
    }
]



//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 6. Portfolio
export const PORTFOLIO = [
    {
        name: 'PROJECT1',
        description: 'PROJECT1_DESCRIPTION',
        image: require('../config/assets/images/portfolio1.jpg'),
        demo: 'null',
        github: 'https://github.com'
    },
    {
        name: 'PROJECT2',
        description: 'PROJECT2_DESCRIPTION',
        image: require('../config/assets/images/portfolio2.jpg'),
        demo: '#',
        github: 'null'
    },
    {
        name: 'PROJECT3',
        description: 'PROJECT3_DESCRIPTION',
        image: require('../config/assets/images/portfolio3.jpg'),
        demo: '#',
        github: '#'
    },
]




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 7. Hire
export const HIRE = true




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 8. Contact
// Phone
export const PHONE = "+1 300 0000";

// Email
export const EMAIL = "jane.doe@outlook.com";

// Address
export const ADDRESS = "India";